var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-10" }, [
    _c(
      "div",
      { staticClass: "p-30 bg-white flex justify-center" },
      [
        _c(
          "el-form",
          {
            ref: "form",
            staticStyle: { width: "500px" },
            attrs: { model: _vm.wForm, "label-width": "100px" },
          },
          [
            _c("el-form-item", { attrs: { label: "手机号码：" } }, [
              _c("div", [_vm._v(_vm._s(_vm.agentInfo.phone))]),
            ]),
            _vm._v(" "),
            _c("el-form-item", { attrs: { label: "验证码：" } }, [
              _c(
                "div",
                { staticClass: "flex" },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.wForm.captche_num,
                      callback: function ($$v) {
                        _vm.$set(_vm.wForm, "captche_num", $$v)
                      },
                      expression: "wForm.captche_num",
                    },
                  }),
                  _vm._v(" "),
                  _c("auth-code", {
                    ref: "authCode",
                    on: {
                      authCode: function ($event) {
                        return _vm.getAuthCode()
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "新密码：" } },
              [
                _c("el-input", {
                  attrs: { type: "password" },
                  model: {
                    value: _vm.wForm.cur_cash_pwd,
                    callback: function ($$v) {
                      _vm.$set(_vm.wForm, "cur_cash_pwd", $$v)
                    },
                    expression: "wForm.cur_cash_pwd",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "确认密码：" } },
              [
                _c("el-input", {
                  attrs: { type: "password" },
                  model: {
                    value: _vm.wForm.re_cash_pwd,
                    callback: function ($$v) {
                      _vm.$set(_vm.wForm, "re_cash_pwd", $$v)
                    },
                    expression: "wForm.re_cash_pwd",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.postEdit(2)
                      },
                    },
                  },
                  [_vm._v("确定")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }